"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _bookingCompanies = require("utils/bookingCompanies");

var _pacomo = require("utils/pacomo");

var _FormLink = require("./forms/FormLink");

var _FormLink2 = _interopRequireDefault(_FormLink);

var _utils = require("../utils/mappings/utils");

var _links = require("../utils/mappings/links");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Legal = function Legal(_ref) {
    var bookingCompany = _ref.bookingCompany,
        primaryCustomerCall = _ref.primaryCustomerCall,
        primaryCustomer = _ref.primaryCustomer;

    if (!bookingCompany || !primaryCustomerCall || !primaryCustomer) return _react2.default.createElement("div", null);

    var isPrimaryCustomerLoading = primaryCustomerCall.isFetching;
    var countryCode = (0, _utils.getCountryCodeFromCustomerData)(primaryCustomer);
    var bookingCompanyObject = _bookingCompanies.bookingCompanies[bookingCompany.id] || _bookingCompanies.bookingCompanies[1];
    var privacyLink = (0, _utils.getLink)(bookingCompany.id, _links.PRIVACY_LINK_MAP, countryCode);

    return _react2.default.createElement(
        "p",
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: "legal",
            defaultMessage: "All personal information provided to {bookingCompanyName} by travellers is collected,\n                            used, and disclosed only in accordance with the {bookingCompanyName} Privacy Policy,\n                            which can be accessed anytime at: {privacyPolicyLink}.",
            values: {
                bookingCompanyName: bookingCompanyObject.name,
                privacyPolicyLink: !isPrimaryCustomerLoading && _react2.default.createElement(
                    _FormLink2.default,
                    { link: privacyLink },
                    privacyLink
                )
            }
        })
    );
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        bookingCompany: state.booking.booking_company,
        primaryCustomerCall: state.apiCalls.primaryCustomerData,
        primaryCustomer: state.primaryCustomer
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _pacomo.pacomoTransformer)(Legal));
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/Legal.js
// module id = 1299
// module chunks = 0